import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, Text } from '@leverege/ui-elements'
import Editor from '@monaco-editor/react'

import S from './JsonEditorDialog.css'

// import style from './jsonEditorDialog.css'

export default class JsonEditorDialog extends React.Component {
  
  static propTypes = {
    title : PropTypes.string,
    message : PropTypes.oneOfType( [ PropTypes.string, PropTypes.element ] ),
    value : PropTypes.object,
    ok : PropTypes.string,
    cancel : PropTypes.string
  }

  static defaultProps = {
    ok : 'Ok',
    cancel : 'Cancel',
    title : 'JSON Editor',
    message : 'Enter the JSON object'
  }

  constructor( props ) {
    super( props );
    const json = props.value ? JSON.stringify( props.value, null, 2 ) : null
    this.state = { value : json || '', showError : false }
  }

  componentWillReceiveProps( nProps ) {
    let json
    try {
      json = nProps.value ? JSON.stringify( nProps.value, null, 2 ) : null
    } catch ( ex ) {
      console.log( 'json parse error', ex, nProps.value )

    }
    this.setState( { value : json || '' } )
  }

  onOk = () => {
    const { value } = this.state
    const { onOk } = this.props

    let val = value
    if ( val == null || val.trim().length === 0 ) {
      val = null
    } else {
      try {
        const json = JSON.parse( val )
        if ( !Array.isArray( json ) && typeof json === 'object' ) {
          val = json
        } else {
          this.setState( { showError : true } )
          return
        }
      } catch ( ex ) {
        this.setState( { showError : true } )
        return
      }
    }

    if ( onOk ) {
      onOk( val );
    }
  }

  onCancel = () => {
    const { onCancel } = this.props
    if ( onCancel ) {
      onCancel();
    }
  }

  onChange = ( val ) => {

    // this.value = val;
    this.setState( { value : val, showError : false } )
  }

  render() {
    const { value, showError } = this.state
    const { ok, cancel, message, title, show } = this.props;

    return (
      <Dialog.Question
        variant="dialogLarge"
        show={show}
        onOkay={this.onOk}
        onCancel={this.onCancel}
        onClose={this.onCancel}
        okay={ok}
        cancel={cancel}
        title={title}>
        <div style={{ display : 'flex', flexDirection : 'column', height : '50vh', position : 'relative' }}>
          {message}
          <Editor
            options={{
              minimap : {
                enabled : false
              }
            }}
            width="100%"
            defaultLanguage="json"
            value={value}
            onChange={this.onChange}
            theme="light" />
        </div>
        {showError ?
          <Text variant="twoFactorWarning">Invalid JSON entered. Fix all errors and then click Ok.</Text> :
          <div className={S.placeholder} />}
      </Dialog.Question>
    )
  }

}
